import { render, staticRenderFns } from "./public-red-chirp-provide-new-payment-method-thanks.vue?vue&type=template&id=58994313&scoped=true&"
import script from "./public-red-chirp-provide-new-payment-method-thanks.vue?vue&type=script&lang=js&"
export * from "./public-red-chirp-provide-new-payment-method-thanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58994313",
  null
  
)

export default component.exports